module.exports = __webpack_public_path__ + "static/img/product_1_3.ea47efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_3.png
// module id = 2jO/
// module chunks = 34